import { tv } from "@otomoro/helpers/mergeClasses";
import { VariantProps } from "tailwind-variants";

export const styles = tv({
  slots: {
    base: 'relative mx-2 mt-2 lg:mt-6 lg:after:content-[\'\'] lg:after:absolute lg:after:block lg:after:bg-black lg:after:w-full lg:after:h-[1.5px] lg:after:bottom-0 lg:after:left-0 max-w-[69rem] lg:mx-auto flex flex-col',
    list: 'inline-flex space-x-1 items-center mt-1 lg:mb-2',
    item: 'w-fit',
    link: 'block p-[1.2rem] rounded-full border-[1.5px] border-black w-fit h-fit hover:border-mainPink hover:bg-mainPink transition-colors duration-200 ease-in-out',
  }
})

export type SharedLinksVariant = VariantProps<typeof styles>